<div id="{{id}}" class="{{#if hideCriteriaFirstTime}}hidden{{/if}}">
    <field-item item="criteriaFormModel">
        <field-hcombo id="criteria-selectByType" name="type" label="" {options}="typeOptions"></field-hcombo>

        <uda-list of="flags" name="flag" label-key="uda.flag.severalSelected" {visible}="states.flag"
                  class="inlineGroup"></uda-list>
    </field-item>
</div>
